import { MenuService } from '@shared/services/menu.service';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter } from '@angular/core';
import { RoutesPath } from '@shared/routes-path';
import { BaseComponent } from '@shared/components/base.component';
import { AnimationOptions } from 'ngx-lottie';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@shared/models/response.model';
import { User } from '@shared/models/user/user.model';
import { Error } from '@shared/interfaces/error.interface';
import { AuthorizationService } from '@layouts/default/components/auth/auth.service';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent extends BaseComponent implements AfterViewInit {
  layoutTitle: string = this.translate.instant('GLOBAL.welcome');
  RoutesPath: any = RoutesPath;
  titlePageEmitter: EventEmitter<any> = new EventEmitter();
  options: AnimationOptions = {
    path: 'assets/data/animation.json',
  };
  currentAuthPage: string = null;
  dataParams: any = null;
  loading: boolean = false;
  authFromHelpUkraine: boolean = false;
  coverImage: string;
  authWcd = false;

  displayDialog: boolean = true;

  constructor(
    public route: ActivatedRoute,
    public authService: AuthorizationService,
    private _cdr: ChangeDetectorRef,
    public menuService: MenuService
  ) {
    // update layout title (left side)
    super();
    const subTitle = this.titlePageEmitter.subscribe((res: string) => {
      this.layoutTitle = res;
      this._cdr.detectChanges();
    });
    this.someSubscriptions.add(subTitle);
  }

  ngAfterViewInit() {
    const subDataAuth = this.route.queryParamMap.subscribe((data: any) => {
      if (data.params.auth) {
        const { auth, ...othersParams } = data.params;
        setTimeout(() => (this.currentAuthPage = auth));
        this.dataParams = othersParams;
        this.coverImage = this.menuService.getCoverImage();
        this.authFromHelpUkraine = this.menuService.isUkraineUrl();
        this.authWcd = this.menuService.isWcd();
        setTimeout(() => this.showDialog());
      } else {
        if (this.displayDialog) {
          setTimeout(() => this.hideDialog());
        }
        setTimeout(() => (this.currentAuthPage = null));
      }
    });
    this.someSubscriptions.add(subDataAuth);
  }

  userAccess() {
    const subUser = this.authService.userData().subscribe((resUser: Response<User>) => {
      const user = new User(resUser.data);
      const subGroups = this.storage.setUser(user).subscribe(() => {
        this.storage.setUserSettings({});
        this.languageService.updateCurrentLang(user.language.code);
        this.closeAuthModal();

        this.toast.success(
          this.translate.instant('AUTH.welcome') + user.username,
          this.translate.instant('AUTH.login_success')
        );
        this.loading = false;
      });
      this.someSubscriptions.add(subGroups);
    }, this.onUserAccessError.bind(this));
    this.someSubscriptions.add(subUser);
  }

  onUserAccessError(error: Error) {
    this.loading = false;
    this.storage.logout();
    this.toast.error(
      this.translate.instant('AUTH.server_problem'),
      this.translate.instant('AUTH.login_error')
    );
  }

  closeAuthModal() {
    this.hideDialog();
    this.storage.noScrollAfterChangeRoute = true;
    this.router.navigate([], { relativeTo: this.route, queryParams: this.dataParams });
  }

  public showDialog(): void {
    this.displayDialog = true;
  }

  public hideDialog(): void {
    this.displayDialog = false;
  }

  loginNormal() {
    return !this.authFromHelpUkraine && !this.authWcd;
  }
}
